import { type GraphQLTaggedNode } from 'react-relay';
import { type ReaderFragment } from 'relay-runtime';

export type RelayFragmentMetadata = {
	fragmentName: string | null;
	fragmentType: string | null;
};

export function getRelayFragmentMetadata(
	fragment: GraphQLTaggedNode | ReaderFragment | null | undefined,
): RelayFragmentMetadata {
	if (!fragment || typeof fragment !== 'object') {
		return {
			fragmentName: null,
			fragmentType: null,
		};
	}

	return {
		fragmentName: 'name' in fragment && typeof fragment.name === 'string' ? fragment.name : null,
		fragmentType: 'type' in fragment && typeof fragment.type === 'string' ? fragment.type : null,
	};
}

export function getRelayFragmentIdKind(fragmentId: string | null | undefined): string {
	if (!fragmentId) {
		return 'none';
	}

	if (fragmentId.startsWith('$ROOT_QUERY')) {
		return 'root-query';
	}

	if (fragmentId.startsWith('$')) {
		return 'nested-client';
	}

	if (/^[A-Za-z_][\w-]*:/.test(fragmentId)) {
		return 'entity';
	}

	return 'unknown';
}
